var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_0_20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 12V4.5H0.75V12H11.25ZM11.25 12H16.5V9L14.25 6.75H11.25M4.125 14.625C4.12599 14.923 4.24521 15.2085 4.45649 15.4187C4.66776 15.629 4.95383 15.7467 5.25187 15.7462C5.54991 15.7458 5.83558 15.627 6.04615 15.4161C6.25672 15.2052 6.37499 14.9193 6.37499 14.6213C6.37499 14.3232 6.25672 14.0373 6.04615 13.8264C5.83558 13.6155 5.54991 13.4967 5.25187 13.4963C4.95383 13.4958 4.66776 13.6135 4.45649 13.8238C4.24521 14.034 4.12599 14.3195 4.125 14.6175M13.875 14.625C13.876 14.923 13.9952 15.2085 14.2065 15.4187C14.4178 15.629 14.7038 15.7467 15.0019 15.7462C15.2999 15.7458 15.5856 15.627 15.7962 15.4161C16.0067 15.2052 16.125 14.9193 16.125 14.6213C16.125 14.3232 16.0067 14.0373 15.7962 13.8264C15.5856 13.6155 15.2999 13.4967 15.0019 13.4963C14.7038 13.4958 14.4178 13.6135 14.2065 13.8238C13.9952 14.034 13.876 14.3195 13.875 14.6175",
    stroke: "#4A4857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIdle);
export default __webpack_public_path__ + "static/media/delivery-idle.b9c28498aca4ff6e97ce28026253751c.svg";
export { ForwardRef as ReactComponent };